module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Thin.41773ad.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Thin.otf
// module id = dLEd
// module chunks = 0